import { CampaignsState } from './types/types'

export const getImportStep = (slice: CampaignsState) => slice.importStep

export const getSelectedCampaign = (slice: CampaignsState) => slice.importData.selectedCampaign

export const getCampaignPayload = (slice: CampaignsState) => slice.importData.campaignPayload
